import React, { Component } from 'react';
import './SubNavbar.css';
import { post, get } from '../../custom_libraries/serverRequests';
import globalVariables from '../../custom_libraries/globalVariables';
import { getFreshToken } from '../../custom_libraries/auth';
import urls from '../../custom_libraries/urls';
import './whatinfo.css';
import { Button} from '@mui/material';
import Alert from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';

class WhatInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedInfo: [], // Now stores an array of selected options
      success: false,
      error: false,
      error1 :false,
      warning : false,
      open_progress_bar: false,
    };
  }

  componentDidMount() {
    this.fetchUserSettings();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
        this.state.error !== prevState.error ||
        this.state.error1 !== prevState.error1 ||
        this.state.success !== prevState.success ||
        this.state.warning !== prevState.warning
    ) {
        if (
            this.state.error ||
            this.state.error1 ||
            this.state.success ||
            this.state.warning
        ) {
            setTimeout(() => {
                this.setState({
                    error: false,
                    success:false,
                    error1: false,
                    warning: false
                });
            }, 3000); // 3 second
        }
    }
}
  
  fetchUserSettings = async () => {
    console.log("--------Fetching Notification Settings--------");
    try {
      this.startLoading();
      let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
      let headers = {
        'content-type': 'application/json',
        'Authorization': `Bearer ${access_token}`
      };
  
      const response = await get(urls.NOTIFICATION_SETTINGS_LIST, headers);
      this.stopLoading();
      console.log("response-----", response);
      console.log("response[0].notification_problems", response[0].notification_problems);
      
      if (response !== false && response[0].notification_problems) {
        let notificationProblems = response[0].notification_problems.trim();

          // If notification_problems is "{}" (string), set an empty array
          if (notificationProblems === "{}") {
            console.warn("Empty notification problems detected.");
            // this.setState({ warning: true });
            return;
          }
        // Convert "{'Liveness','Time'}" → ["Liveness", "Time"]
        let selectedProblems = response[0].notification_problems
          .replace(/{|}/g, '') // Remove {}
          .replace(/'/g, '') // Remove single quotes
          .split(',') // Convert to array
          .map(item => item.trim()); // Trim spaces
  
        console.log("Parsed notification problems:", selectedProblems);
        this.setState({ selectedInfo: selectedProblems });

      }
    } catch (error) {
      console.error("Error fetching user settings:", error);
      // this.setState({error1:true});
    }
  };

  handleButtonClick = (info) => {
    this.setState((prevState) => {
      let updatedInfo = [...prevState.selectedInfo];
  
      if (updatedInfo.includes(info)) {
        // Remove if already selected
        updatedInfo = updatedInfo.filter(item => item !== info);
      } else {
        // Add if not already selected
        updatedInfo.push(info);
      }
  
      return { selectedInfo: updatedInfo };
    });
  };

  // handleButtonClick = (info) => {
  //   this.setState({ selectedInfo: info });
  // };

  jsonData = () => {
    return JSON.stringify({
      notification_problems: `{${this.state.selectedInfo.map(item => `'${item}'`).join(',')}}`
    });
  };

  handleSave = async () => {
    console.log("Selected Info Saved:", this.state.selectedInfo);
    this.startLoading();
    let access_token = localStorage.getItem(globalVariables.AUTH_TOKEN);
    let headers = {
      'content-type': 'application/json',
      'Authorization': `Bearer ${access_token}`,
    };

    try {
      let response = await post(urls.NOTIFICATION_SETTINGS_CREATE, this.jsonData(), headers);
      console.log("Response from backend:", response);
      this.stopLoading();
      if (response) {
        // alert("Settings saved successfully.");
        this.setState({success: true})
      } else {
        // alert("Error saving settings. Please try again.");
        this.setState({error: true})
      }
    } catch (error) {
      console.error("Error while saving settings:", error);
      // alert("An error occurred. Please try again.");
      this.setState({error: true})
    }
  };

  startLoading = () => {
    this.setState({ open_progress_bar: true})
  }
  
  stopLoading = () => {
      this.setState({ open_progress_bar: false})
  }

  render() {
    const{error, success, error1, warning} = this.state
    const buttonOptions = ['Liveness', 'HDD Status', 'Time', 'Recording', 'Image Health'];
    return (
      <div>
        <>
          <div style={{marginLeft:'15%', width:'80%'}}>
              { error ? (
                          <Alert severity="error">Error saving settings. Please try again!</Alert>
                      ) : success ? (
                          <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                              "Settings saved successfully."
                          </Alert>
                      ) : error1 ? (
                        <Alert severity="error">
                            "Server Error occured while fetching user settings:"
                        </Alert>
                      ): warning ? (
                        <Alert severity="warning">
                            "No type is set to receive information!"
                        </Alert>
                      ): null}
          </div>
          <div className='what-info' style={{ maxWidth: "50%", marginTop: "5%" }}>
            <h3>What Info ?</h3>
            <p style={{ fontSize: "14px", marginBottom: "10px", textAlign: "center" }}>
              Select the problem type to receive information about
            </p>

            <div className='alert-btns' style={{ marginTop: "25px" }}>
              {buttonOptions.map((info) => (
                  <button
                    key={info}
                    className={`what-btn ${this.state.selectedInfo.includes(info) ? 'selected' : ''}`}
                    onClick={() => this.handleButtonClick(info)}
                  >
                    {info}
                  </button>
                ))}
            </div>
            <div>
            <Button id="rowsPerPageButton" style={{marginTop:'20px'}}
                onClick={this.handleSave} 
                > Save</Button>
            </div>

          </div>
        </>
        {/* Backdrop with Circular Progress */}
        <Backdrop open={this.state.open_progress_bar}>
          <div className="custom-spinner">
              <div className="circle"></div>
              <div className="circle tilted"></div>
              <img src={WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
          </div>
        </Backdrop>
      </div>
    );
  }
}

export default WhatInfo;